import { AxiosResponse } from 'axios';
import api from '../../base';
import { GlobalStockSwitchResult } from './stockApiTypes';
import { mockGlobalStockSwitchResult } from './stockMock';

const SWITCH_TO_GLOBAL_PATH = 'management/partners/stock/switch-to-global';

// eslint-disable-next-line import/prefer-default-export
export async function switchToGlobalStock(): Promise<AxiosResponse<GlobalStockSwitchResult>> {
  return api.post<GlobalStockSwitchResult>(SWITCH_TO_GLOBAL_PATH);
}

api.mock.onPost(SWITCH_TO_GLOBAL_PATH).reply(200, mockGlobalStockSwitchResult);
